/* eslint-disable max-len */
/* eslint-disable max-classes-per-file */
import React from 'react';
import PropTypes from 'prop-types';

import Item from './Item';
import ItemWithChildren from './ItemWithChildren';

const MenuTree = ({ items, collapsed }) => {
  return (
    <ul
      id="side-main-menu"
      className="side-menu"
      style={{ WebkitTapHighlightColor: 'transparent' }}>
      {items &&
        items.map(item => {
          if (item.children) {
            return <ItemWithChildren collapsed={collapsed} key={item.id} item={item} />;
          }
          return <Item collapsed={collapsed} key={item.id} item={item} />;
        })}
    </ul>
  );
};

MenuTree.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  collapsed: PropTypes.bool.isRequired,
};

export default MenuTree;
